var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.576406 13.8383C0.575773 16.1069 1.17315 18.3219 2.30905 20.2743L0.467773 26.945L7.34771 25.155C9.25062 26.1829 11.3827 26.7215 13.5493 26.7216H13.555C20.7073 26.7216 26.5295 20.9467 26.5326 13.8485C26.534 10.4089 25.1852 7.17456 22.7348 4.74122C20.2847 2.30808 17.0263 0.96739 13.5544 0.96582C6.40124 0.96582 0.579465 6.74047 0.576512 13.8383",
    fill: "url(#paint0_linear_15_34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.112852 13.8342C0.112113 16.1844 0.730898 18.4787 1.9073 20.5009L0 27.4107L7.12663 25.5566C9.09025 26.6189 11.3011 27.179 13.5507 27.1799H13.5565C20.9655 27.1799 26.9968 21.1972 27 13.8449C27.0013 10.2817 25.604 6.93113 23.066 4.4106C20.5277 1.8904 17.1527 0.501465 13.5565 0.5C6.1463 0.5 0.115805 6.48186 0.112852 13.8342ZM4.35702 20.1527L4.09092 19.7335C2.97232 17.9687 2.38191 15.9292 2.38275 13.8351C2.38507 7.72397 7.39737 2.75209 13.5608 2.75209C16.5455 2.75335 19.3506 3.90786 21.4604 6.00256C23.5701 8.09747 24.7309 10.8822 24.7302 13.8441C24.7275 19.9552 19.7151 24.9277 13.5565 24.9277H13.5521C11.5468 24.9266 9.58015 24.3923 7.86502 23.3825L7.45685 23.1423L3.22777 24.2425L4.35702 20.1527Z",
    fill: "url(#paint1_linear_15_34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1966 8.25943C9.94491 7.70447 9.68008 7.69327 9.44077 7.68354C9.24481 7.67516 9.0208 7.67579 8.79699 7.67579C8.57298 7.67579 8.209 7.75941 7.90135 8.09272C7.59338 8.42635 6.72559 9.23258 6.72559 10.8724C6.72559 12.5121 7.9293 14.097 8.0971 14.3196C8.26511 14.5417 10.4209 18.0145 13.8351 19.3505C16.6727 20.4607 17.2501 20.2399 17.8659 20.1842C18.4819 20.1288 19.8534 19.3782 20.1332 18.5999C20.4132 17.8217 20.4132 17.1547 20.3293 17.0153C20.2453 16.8764 20.0213 16.793 19.6854 16.6264C19.3495 16.4598 17.6979 15.6534 17.3901 15.5421C17.0821 15.431 16.8582 15.3755 16.6342 15.7092C16.4101 16.0424 15.7669 16.793 15.5708 17.0153C15.375 17.2381 15.1789 17.2658 14.8431 17.0991C14.507 16.9319 13.4252 16.5803 12.1417 15.445C11.1431 14.5615 10.469 13.4705 10.273 13.1368C10.0771 12.8036 10.252 12.623 10.4205 12.4569C10.5714 12.3075 10.7565 12.0677 10.9246 11.8731C11.0921 11.6785 11.148 11.5396 11.26 11.3173C11.3721 11.0948 11.316 10.9002 11.2322 10.7335C11.148 10.5668 10.4952 8.91842 10.1966 8.25943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_34",
    x1: 1303.71,
    y1: 2598.88,
    x2: 1303.71,
    y2: 0.96582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_34",
    x1: 1350,
    y1: 2691.57,
    x2: 1350,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.3ee6f055c979b5b8debb031c96760fa1.svg";
export { ForwardRef as ReactComponent };